import first from "lodash/first";
import type { FunctionComponent } from "react";

import { DropdownField } from "scmp-app/components/search/search-result-panel/refine-search/dropdown-field";

import { SectionOptions } from "./const";
import ServerIcon from "./icon-server.svg";
import { FieldGroup, FieldLabel } from "./styles";

type Props = {
  onChange: (sectionIds: string[]) => void;
  sectionIds: string[];
};

export const SectionField: FunctionComponent<Props> = ({ onChange, sectionIds }) => {
  const selectedValue = first(sectionIds) ?? "";
  const options = [{ text: "All Sections", value: "" }, ...SectionOptions];

  return (
    <FieldGroup>
      <FieldLabel>Section</FieldLabel>
      <DropdownField<string>
        icon={<ServerIcon />}
        onOptionSelect={option => onChange(option.value ? [option.value] : [])}
        options={options}
        placeholder="All Sections"
        selectedOptionValue={selectedValue}
        withCount
      />
    </FieldGroup>
  );
};

SectionField.displayName = "SectionField";
